// extracted by mini-css-extract-plugin
export default {"rightBar":"style_rightBar__cPTey","title":"style_title__pUd15","text":"style_text__abldw","subtitle":"style_subtitle__vH+g1"};